export const ORDER_DETAILS_MODAL_CLOSED = 'ORDER_DETAILS_MODAL_CLOSED';
export const GET_ORDER_DETAILS_SUCCESS = 'GET_ORDER_DETAILS_SUCCESS';
export const GET_ORDER_DETAILS_FAILURE = 'GET_ORDER_DETAILS_FAILURE';
export const EXIT_CREATE_RETURN = 'EXIT_CREATE_RETURN';
export const MARK_PAID = 'MARK_PAID';
export const VALIDATE_ADDRESS_REQUEST = 'VALIDATE_ADDRESS_REQUEST';
export const VALIDATE_ADDRESS_SUCCESS = 'VALIDATE_ADDRESS_SUCCESS';
export const VALIDATE_ADDRESS_FAILURE = 'VALIDATE_ADDRESS_FAILURE';
export const MARK_AS_MODIFIED = 'MARK_AS_MODIFIED';
export const CREATE_ANOTHER_SHIPMENT_SUCCESS = 'CREATE_ANOTHER_SHIPMENT_SUCCESS';
export const ORDER_DETAILS_MODAL_OPENED_FROM_SHIPMENT_FOR_RETURN = 'ORDER_DETAILS_MODAL_OPENED_FROM_SHIPMENT_FOR_RETURN';
export const SET_SELECTED_RETURN_SHIPMENT = 'SET_SELECTED_RETURN_SHIPMENT';

export const ORDER_DETAILS_MODAL_OPENED = 'ORDER_DETAILS_MODAL_OPENED';
export const openedOrderDetailModal = ({ salesOrderId, modalId, suppressRouting = false, fulfillmentPlanId }) => {
  return {
    type: ORDER_DETAILS_MODAL_OPENED,
    salesOrderId,
    modalId,
    suppressRouting,
    fulfillmentPlanId,
  };
};

export const ORDER_DETAILS_GO_TO_ROUTE = 'ORDER_DETAILS_GO_TO_ROUTE';
export const goToOrderDetails = ({ salesOrderId, selectOrderInGrid = false, fulfillmentPlanId, replaceRoute }) => ({
  type: ORDER_DETAILS_GO_TO_ROUTE,
  fulfillmentPlanId,
  salesOrderId,
  selectOrderInGrid,
  selectedOrderIds: [fulfillmentPlanId],
  replaceRoute,
});

export const closedOrderDetailModal = () => {
  return {
    type: ORDER_DETAILS_MODAL_CLOSED,
  };
};

export const GET_ORDER_DETAILS_REQUEST = 'GET_ORDER_DETAILS_REQUEST';
export const requestOrderDetails = (recalculateStatuses = false, suppressRouting = false, requestLatestData = false) => {
  return {
    type: GET_ORDER_DETAILS_REQUEST,
    recalculateStatuses,
    suppressRouting,
    requestLatestData,
  };
};

// TODO: HIT THIS WITH A HAMMER
export const getOrderDetailsSuccess = (suppressRouting = false, fulfillmentPlanId) => {
  return {
    type: GET_ORDER_DETAILS_SUCCESS,
    suppressRouting,
    fulfillmentPlanId,
  };
};

export const getOrderDetailsFailure = (error) => {
  return {
    type: GET_ORDER_DETAILS_FAILURE,
    error,
  };
};

export const SILENTLY_GET_ORDER_DETAILS = 'SILENTLY_GET_ORDER_DETAILS';
export const silentlyGetOrderDetails = (salesOrderId) => ({
  type: SILENTLY_GET_ORDER_DETAILS,
  salesOrderId,
});

export const exitCreateReturn = () => ({
  type: EXIT_CREATE_RETURN,
});

export const SET_SELECTED_RETURN_ITEMS = 'SET_SELECTED_RETURN_ITEMS';
export const setSelectedReturnItems = ({ selectedItems, salesOrderId }) => ({
  type: SET_SELECTED_RETURN_ITEMS,
  selectedItems,
  salesOrderId,
});

export const setSelectedReturnShipment = (fulfillmentId) => ({
  type: SET_SELECTED_RETURN_SHIPMENT,
  fulfillmentId,
});

export const markPaid = ({
  salesOrderId,
  internalNote,
  paidDateUtc,
  orderTotal,
  shippingAmountPaid,
  orderTotalCurrencyCode,
  shippingAmountPaidCurrencyCode,
}) => {
  return {
    type: MARK_PAID,
    salesOrderId,
    internalNote,
    paidDateUtc,
    orderTotal,
    shippingAmountPaid,
    orderTotalCurrencyCode,
    shippingAmountPaidCurrencyCode,
  };
};

export const markOrderAsModified = () => ({
  type: MARK_AS_MODIFIED,
});

export const createAnotherShipmentSuccess = (salesOrderId, newFulfillmentPlanId) => ({
  type: CREATE_ANOTHER_SHIPMENT_SUCCESS,
  salesOrderId,
  newFulfillmentPlanId,
});

export const SET_ORDER_GRID_META_DATA = 'SET_ORDER_GRID_META_DATA';
export const setOrderGridMetaData = (canGoToPreviousOrder, canGoToNextOrder, previousOrderId, nextOrderId, showArrows) => ({
  type: SET_ORDER_GRID_META_DATA,
  canGoToPreviousOrder,
  canGoToNextOrder,
  previousOrderId,
  nextOrderId,
  showArrows,
});

export const ADD_SALES_ORDER_TO_BATCH_FROM_ORDER_DETAILS = 'ADD_SALES_ORDER_TO_BATCH_FROM_ORDER_DETAILS';
export const addSalesOrderToBatchFromOrderDetails = (fulfillmentPlanSetId, salesOrderId) => ({
  type: ADD_SALES_ORDER_TO_BATCH_FROM_ORDER_DETAILS,
  fulfillmentPlanSetId,
  salesOrderId,
});

export const orderDetailsModalOpenedFromShipmentForReturn = ({ isReturnsFromShipment, fulfillmentPlanId }) => ({
  type: ORDER_DETAILS_MODAL_OPENED_FROM_SHIPMENT_FOR_RETURN,
  isReturnsFromShipment,
  shipmentIdForReturns: fulfillmentPlanId,
});

export const ORDER_DETAILS_FLIP_EDIT_ORDER_ITEMS = 'ORDER_DETAILS_FLIP_EDIT_ORDER_ITEMS';
export const onFlipOrderDetailsEditOrderItemsMode = () => ({
  type: ORDER_DETAILS_FLIP_EDIT_ORDER_ITEMS,
});

export const ORDER_DETAILS_SAVE_ORDER_ITEMS_REQUEST = 'ORDER_DETAILS_SAVE_ORDER_ITEMS_REQUEST';
export const orderDetailsSaveOrderItemsRequest = (workingOrderItems) => ({
  type: ORDER_DETAILS_SAVE_ORDER_ITEMS_REQUEST,
  workingOrderItems,
});

export const ORDER_DETAILS_SAVE_ORDER_ITEMS_SUCCESS = 'ORDER_DETAILS_SAVE_ORDER_ITEMS_SUCCESS';
export const saveOrderDetailsOrderItemsSuccess = (response) => ({
  type: ORDER_DETAILS_SAVE_ORDER_ITEMS_SUCCESS,
  response,
});

export const ORDER_DETAILS_PATCH_ORDER_ITEMS = 'ORDER_DETAILS_PATCH_ORDER_ITEMS';
export const patchOrderDetailsOrderItems = (items) => ({
  type: ORDER_DETAILS_PATCH_ORDER_ITEMS,
  items,
});

export const ORDER_DETAILS_RESHIP_SUCCESS = 'ORDER_DETAILS_RESHIP_SUCCESS';
export const orderDetailsReshipSuccess = ({ salesOrderId, newFulfillmentPlanId }) => ({
  type: ORDER_DETAILS_RESHIP_SUCCESS,
  salesOrderId,
  newFulfillmentPlanId,
});
